export class TatMonitorSearchModel {
    accessionNumber: string;
    patientMrn: string;
    orderNumber: string;
    labSectionId: string;
    fromOrderDate: Date;
    toOrderDate: Date;
}